import {AxiosError, AxiosRequestConfig, AxiosResponse} from 'axios';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {I18N_NS} from './constants/names';

interface ErrorListElem {
    message: string;
    code: string;
}

export interface RestError extends Error {
    status?: number;
    config?: AxiosRequestConfig;
    code?: string;
    fullErrorsList: Array<ErrorListElem>;
}

export function createRestError(err: AxiosError): RestError {
    if (!err.response) {
        const unknownError = new Error(
            err.message ?? i18next.t('errors.unknown', {ns: I18N_NS}),
        ) as RestError;
        unknownError.fullErrorsList = [];
        return unknownError;
    }

    const {status, data, config} = err.response as AxiosResponse;

    let message: string;
    let code: string | undefined;
    let fullErrorsList: Array<ErrorListElem>;
    if (status === 403) {
        message = i18next.t('errors.noAccess', {ns: I18N_NS});
        code = '0403';
        fullErrorsList = [];
    } else if (status === 404 && data.errors == null) {
        message = i18next.t('errors.notFound', {ns: I18N_NS});
        code = '0404';
        fullErrorsList = [];
    } else if (status === 500 && data.errors == null) {
        message = i18next.t('errors.server', {ns: I18N_NS});
        code = '0500';
        fullErrorsList = [];
    } else {
        const errorsList = data.errors || data;
        message =
            errorsList?.message ||
            errorsList?.[0]?.message ||
            errorsList?.[0]?.error ||
            i18next.t('errors.occurred', {ns: I18N_NS});
        code = errorsList?.[0]?.code;
        fullErrorsList = errorsList;
    }

    const result = new Error(message) as RestError;
    result.name = 'RestError';
    result.status = status;
    result.config = config;
    result.code = code;
    result.fullErrorsList = fullErrorsList;
    return result;
}

export function showRestError(error: RestError) {
    console.debug(error.status, error.code, error.message);
    console.error(error);
    console.error(error.fullErrorsList);
    toast.error(`${error.message}`, {autoClose: 5000});
}
